import dataService from 'src/app.service'

const getOpportunities = id => {
  return dataService.get('/opportunities')
}

export default {
  getOpportunities,
}
